export * from "./env";
export const AVAILABLE_ROLES = [
    { id: 0, name: 'Super Admin' },
    { id: 10, name: 'Manager' },
    { id: 20, name: 'Responsable' },
    { id: 30, name: 'Pubeur' },
];
